import React from 'react';
import { Loader2 } from 'lucide-react';
import './LoadingState.scss';

interface LoadingStateProps {
  message?: string;
  fullScreen?: boolean;
  iconSize?: number;
  iconColor?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ 
  message = 'Loading...', 
  fullScreen = false,
  iconSize = 32, // Increased default size
  iconColor
}) => {
  const style = iconColor ? { color: iconColor } : {};
  
  return (
    <div className={`loading-state ${fullScreen ? 'fullscreen' : ''}`}>
      <Loader2 className="loading-icon" size={iconSize} style={style} />
      <p className="loading-message">{message}</p>
    </div>
  );
};

export default LoadingState; 